module.exports = __webpack_public_path__ + "static/white-teeth-44a64636abb5d3b4b023fa87e8096631.jpg";